<template>
  <BaseModal
    name="consumptionBalanceFourStepModal"
    width="510"
    :clickToClose="false"
    :shiftY="0.5"
    @before-close=""
    @before-open="loadData"
    :adaptive="true"
    height="auto"
    classes="tw-app-modal"
  >
    <div class="tw-app-modal__container">
      <BaseLoader v-if="localLoading" class="tw-rounded-[25px]"></BaseLoader>
      <button
        type="button"
        class="btn-close tw-app-modal__close"
        @click="$modal.hide('consumptionBalanceFourStepModal')"
      ></button>

      <div>
        <div class="tw-app-modal__title">{{ dataLang["reg_company_40"] }}</div>

        <div
          @click="onLoadDoc"
          class="tw-text-[16px] tw-underline tw-cursor-pointer tw-text-center"
        >
          {{ dataLang["reg_company_41"] }}
        </div>

        <div v-html="transformString" class="tw-mt-[15px]"></div>

        <div class="tw-app-modal__footer">
          <button
            @click="$modal.hide('consumptionBalanceFourStepModal')"
            class="tw-app-btn-muted tw-app-btn-muted-lg"
          >
            {{ dataLang["clients_register_text_96"] }}
          </button>
          <button
            @click="sendData"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
          >
            {{ dataLang["reg_company_43"] }}
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import GeneralService from "@/api/GeneralService.js";
import { VeTable } from "vue-easytable";
import httpInstance from "@/http-common";

// TODO Сделать тестовую модалку с евентбасом, рефом, открытием по ссылке https://webdevblog.ru/vue-js-kak-ya-vyzyvaju-metod-v-komponente-izvne-komponenta-v-vue-2/
export default {
  props: {},
  data() {
    return {
      localLoading: false,
      dataForEmit: {},
      pincode: "",
      currentId: null,
      transformString: "",
      dataTable: [],
    };
  },
  methods: {
    loadData({ params }) {
      this.pincode = params?.pincode;

      this.dataForEmit = Object.assign(this.dataForEmit, params);
      // this.dataTable = this.dataForModal.dataTable
      console.log(this.dataForEmit);
      let res = 0;
      this.dataForEmit.dataTable.forEach((x, index) => {
        let fefef = this.dataForEmit.companyIds.find(
          (ww) => ww == x.companies__id
        );
        if (fefef) {
          res = res + x.companies__balance_out;
        }
      });
      this.transformString = this.computedTranslate(
        {
          number: this.dataForEmit.companyIds.length,
          total: res,
        },
        this.dataLang["reg_company_42"]
      );

      // /clients/table/active?count=0&limit=100&total=0&page=0
    },
    beforeClose(event) {
      this.dataForEmit = {};
    },
    computedTranslate(values, tranaslate) {
      let keys = Object.keys(values);
      let tranaslateLocal = tranaslate;
      keys.forEach((keyName) => {
        tranaslateLocal = tranaslateLocal.replace(
          `\\${keyName}\\`,
          values[keyName]
        );
      });
      return tranaslateLocal;
    },
    updateValue(data) {
      this.dataForEmit[data.name] = data.value;
      if (this.$refs[data.name]) {
        this.$refs[data.name].classList.remove("input-error");
      }
    },

    async onLoadDoc() {
      try {
        let dataFrom = await httpInstance.get(
          `/download/bank/${this.dataForEmit.documentId}`,
          {
            responseType: "blob",
          }
        );
        console.log(dataFrom);
        const filename = new Date().toISOString();
        const url = window.URL.createObjectURL(dataFrom.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${filename}.txt`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      } catch (e) {
        console.error(e);
      }
    },
    sendData() {
      this.localLoading = true;
      GeneralService.editOrCreate(
        `/super/companies/balance/out/step4?pincode=${this.pincode}`,
        this.dataForEmit
      )
        .then((gege) => {
          console.log(gege);
          this.$toast.success(gege.data.message);
          this.$modal.show("doneСonsumptionModal");
          this.$modal.hide("consumptionBalanceFourStepModal");
        })
        .catch((e) => {
          console.error(e);
          this.$toast.error(e.response.data.message, { duration: 5000 });
        })
        .finally(() => {
          this.$modal.hide("сonsumptionBalanceFourStepModal");
          this.localLoading = false;
        });
    },
  },
  mounted() {},
  created() {
    GeneralService.get(
      `/settings?fields=company_settings__set_security_pass_for_forbidden`
    )
      .then((data) => {
        this.pincode =
          data.data.data.rows[0].company_settings__set_security_pass_for_forbidden;
      })
      .catch((e) => {});
  },
  beforeDestroy() {},

  computed: {
    ...mapState("translationModule", ["dataLang"]),
  },
};
</script>
